import React, { useState } from 'react';
import { TextField } from '@mui/material';
import BaseDialog, {
  DialogTitle,
  DialogContent,
  DialogActions,
} from '../BaseDialog';
import { Button } from '../../buttons';
import { useNewspaperStore } from '../../../hooks/zustand/newspapers';
import * as NewspapersAPI from '../../../api/Newspapers';
import { track, Events } from '../../../utils/analytics';

interface Props {
  isOpen: boolean;
  newspaperId: string;
  onClose: () => void;
}

export default function CreateEditionDialog({ isOpen, newspaperId, onClose }: Props) {
  const addEdition = useNewspaperStore((state) => state.addEdition);

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setName('');
    setDescription('');
    onClose();
  };

  const handleCreate = async () => {
    setIsLoading(true);
    try {
      const response = await NewspapersAPI.createEdition(newspaperId, {
        name,
        description: description || undefined,
      });
      addEdition(response.data.data);
      track(Events.CreateEdition, { has_description: !!description });
      handleClose();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <BaseDialog open={isOpen} onClose={handleClose}>
      <DialogContent>
        <DialogTitle>New edition</DialogTitle>
        <TextField
          label="Edition name"
          placeholder="e.g. Spring 2026"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          autoFocus
          sx={{ mb: 2 }}
        />
        <TextField
          label="Description (optional)"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth
          multiline
          rows={2}
          sx={{ mb: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          label={isLoading ? 'Creating...' : 'Create edition'}
          onClick={handleCreate}
          disabled={isLoading || !name.trim()}
        />
      </DialogActions>
    </BaseDialog>
  );
}
